<app-loader *ngIf="isLoading"></app-loader>

<div class="container mt-3">
	<div class="d-flex align-items-center gap-2 mb-3">
		<button type="button" class="btn-back" (click)="goBack()" ngbTooltip="Back">
			<i class="bx bx-arrow-back"></i>
		</button>
		<h2 class="mb-0">Reschedules</h2>
	</div>

	<ngx-datatable class="material striped" [rows]="reschedules" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [scrollbarH]="true" [sorts]="[{ prop: 'date_generated', dir: 'asc' }]" *ngIf="reschedules && reschedules.length > 0" (activate)="onActivate($event)">
		<ngx-datatable-column name="#" prop="id" [width]="80"></ngx-datatable-column>
		<ngx-datatable-column name="Appt Date" prop="date_generated" [width]="160">
			<ng-template let-value="value" ngx-datatable-cell-template>
				{{ value | date: "short" }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="Phone" prop="primary_phone" [width]="150">
			<ng-template let-row="row" ngx-datatable-cell-template>
				{{ formatPhone(row.primary_phone) }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="Prospect" prop="company_name" [width]="200"></ngx-datatable-column>
		<ngx-datatable-column name="Campaign" prop="campaign_name" [width]="200">
			<ng-template let-value="value" ngx-datatable-cell-template>
				<span class="badge bg-success campaign-badge">{{ value }}</span>
			</ng-template>
		</ngx-datatable-column>
	</ngx-datatable>

	<div *ngIf="!isLoading && reschedules?.length === 0" class="text-center mt-3">No hay pending reschedules.</div>
</div>

<ng-template #rescheduleModal let-modal>
	<div class="modal-header pb-2">
		<h4 class="modal-title mb-0">
			{{ selectedReschedule?.company_name }}
			<span class="text-muted fs-4">— Lead #{{ selectedReschedule?.prospect_id || selectedReschedule?.lead_id || selectedReschedule?.id }}</span>
		</h4>
		<button type="button" class="btn-close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body pt-2">
		<div class="card mb-3 shadow-sm">
			<div class="card-header fw-bold bg-primary bg-opacity-10">Reschedule</div>
			<div class="card-body">
				<div class="row g-3">
					<div class="col-md-4">
						<label class="form-label fw-bold d-block mb-1">Current Appointment Date</label>
						<div>{{ selectedReschedule?.date_generated | date: "medium" }}</div>
					</div>
					<div class="col-md-6">
						<label class="form-label fw-bold d-block mb-1">New Appointment Date</label>
						<input type="datetime-local" class="form-control" [(ngModel)]="newDate" />
					</div>
					<div class="col-md-2">
						<label class="form-label fw-bold d-block mb-1 invisible">Reschedule</label>
						<button class="btn btn-primary w-100 text-nowrap" (click)="confirmReschedule(modal)">Reschedule</button>
					</div>
				</div>
				<hr />

				<div>
					<label class="form-label fw-bold d-block">Send User Notification</label>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="sendNotification" id="sendNotificationYes" [value]="true" [(ngModel)]="sendNotification" />
						<label class="form-check-label" for="sendNotificationYes">Yes</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="sendNotification" id="sendNotificationNo" [value]="false" [(ngModel)]="sendNotification" />
						<label class="form-check-label" for="sendNotificationNo">No</label>
					</div>
				</div>
			</div>
		</div>

		<div class="card mb-3 shadow-sm">
			<div class="card-header fw-bold bg-primary bg-opacity-10">Lead Information</div>
			<div class="card-body">
				<div class="row g-3">
					<div class="col-md-6">
						<label class="text-muted">Prospect Name</label>
						<div>{{ selectedReschedule?.prospect_name }}</div>
					</div>
					<div class="col-md-6">
						<label class="text-muted">Phone</label>
						<div>
							<a [href]="'tel:' + selectedReschedule?.primary_phone" class="badge bg-success text-decoration-none" (click)="onPhoneClick(selectedReschedule?.primary_phone)">
								{{ formatPhone(selectedReschedule?.primary_phone) }}
							</a>
						</div>
					</div>
					<div class="col-md-6">
						<label class="text-muted">Campaign</label>
						<div>{{ selectedReschedule?.campaign_name }}</div>
					</div>
					<div class="col-md-6">
						<label class="text-muted">Email</label>
						<div>{{ selectedReschedule?.email || "—" }}</div>
					</div>
					<div class="col-md-6">
						<label class="text-muted">City / State</label>
						<div>{{ selectedReschedule?.city }}, {{ selectedReschedule?.state }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="card mb-3 shadow-sm">
			<div class="card-header fw-bold bg-primary bg-opacity-10">Notes</div>
			<div class="card-body">
				<p class="mb-0">{{ selectedReschedule?.notes || "No notes" }}</p>
			</div>
		</div>
	</div>
</ng-template>
